// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__1TOLN","title":"Form_title__1YFQF","defaultInput":"Form_defaultInput__3p7K0","button":"Form_button__2k-0w"};